<template>
  <div class="bg-white shadow-md p-10">
    <h2>Create a workspace</h2>
    <div>
      <p>
        Your workspace contains all your legal documents and can only be accessed by other members of a this workspace.
        <strong>You can be a member of multiple workspaces.</strong>
      </p>
      <p>Create a workspace or ask your workspace owner to invite you to an already existing workspace.</p>
    </div>
    <div>
      <FormKit type="form" @submit="handleSubmit" :disabled="isPending" :input-errors="error?.response.data.errors">
        <FormKit type="text" name="name" label="Workspace Name" placeholder="ACME Global Inc." validation="required"></FormKit>
        <h3>Invite some users</h3>
        <FormKit type="list" name="accounts" dynamic v-slot="{ items, node, value }" :value="['']">
          <FormKit v-for="(item, index) in items" :key="item" :index="index" type="email"></FormKit>
          <LSButton type="secondary" class="mb-4" size="small" variant="outline" @click="() => node.input(value?.concat(''))">
            <PlusIcon class="w-4 h-4 mr-2"></PlusIcon>Add more
          </LSButton>
        </FormKit>
      </FormKit>
    </div>
  </div>
</template>

<script setup lang="ts">
import LSButton from '@/components/LSButton.vue'
import httpClient from '@/utils/httpClient'
import { PlusIcon } from '@heroicons/vue/24/solid'
import { useMutation } from '@tanstack/vue-query'
import { useLsGeneralStore } from '../stores/application'
import { useRouter } from 'vue-router'

const store = useLsGeneralStore()
const router = useRouter()

type newWorkspaceData = {
  name: string
}
const { mutate, isPending, error } = useMutation({
  mutationFn: (data: newWorkspaceData) => {
    return httpClient.post('/v1/workspaces', data)
  },
  onSuccess: async () => {
    await store.loginFromToken()
    router.push({ name: 'home', replace: true })
  },
})

const handleSubmit = async (data: newWorkspaceData) => {
  await mutate(data)
}
</script>
